/* eslint-disable jsx-a11y/anchor-is-valid */
import {useState} from 'react'
import {useFormik} from 'formik'
import {getUserByToken, login} from '../core/_requests'
import {useAuth} from '../core/Auth'
import {toAbsoluteUrl} from '../../../../_metronic/helpers'
import {Languages} from './Languages'
import {loginSchema} from '../../../../_metronic/helpers/crud-helper/validationSchemas'
import {useIntl} from 'react-intl'
import {FormInput, FormSubmitButton} from '../../../../_metronic/helpers/components/FormComponents'

export function Login() {
  const intl = useIntl()
  const [loading, setLoading] = useState(false)
  const {saveAuth, setCurrentUser} = useAuth()
  const theme = localStorage.getItem('kt_theme_mode_value')

  const formik = useFormik({
    initialValues: {
      email: '',
      password: '',
    },
    validationSchema: loginSchema,
    onSubmit: async (values, {setStatus, setSubmitting}) => {
      setLoading(true)
      try {
        const {data: auth} = await login(values.email, values.password)
        saveAuth(auth)
        const {data: user} = await getUserByToken(auth.token)
        setCurrentUser(user)
      } catch (error) {
        console.error(error)
        saveAuth(undefined)
        setStatus('AUTH.VALIDATION.INVALID_LOGIN')
        setSubmitting(false)
        setLoading(false)
      }
    },
  })

  return (
    <form
      className='form w-100'
      onSubmit={formik.handleSubmit}
      noValidate
      id='kt_login_signin_form'
    >
      <div className='d-flex flex-column align-items-center text-center mb-6'>
        {theme === 'light' ? (
          <img
            alt='Logo'
            src={toAbsoluteUrl('/media/logos/GC-Track_light_company.png')}
            className='h-auto w-300px'
          />
        ) : (
          <img
            alt='Logo'
            src={toAbsoluteUrl('/media/logos/GC-Track_dark_company.png')}
            className='h-90px w-100px'
          />
        )}
        <h1>{intl.formatMessage({id: 'AUTH.LOGIN.TITLE'})} </h1>
      </div>

      {formik.status ? (
        <div className='mb-lg-3 alert alert-danger'>
          <div className='alert-text font-weight-bold'>
            {intl.formatMessage({id: `${formik.status}`})}
          </div>
        </div>
      ) : (
        ''
      )}

      <FormInput name='email' type='email' placeholder='AUTH.INPUT.EMAIL' formik={formik} />

      <FormInput
        name='password'
        type='password'
        placeholder='AUTH.INPUT.PASSWORD'
        formik={formik}
      />

      {/* FORGOT PASSWORD */}
      {/* <div className='d-flex flex-stack flex-wrap gap-3 fs-base fw-semibold mb-8'>
        <div />
        <Link to='/auth/forgot-password' className='link-primary'>
          Forgot Password ?
        </Link>
      </div> */}

      {/* SUBMIT BUTTON */}
      <FormSubmitButton
        isLoading={loading}
        isDisabled={loading || !formik.isValid || !formik.touched}
        label='AUTH.LOGIN.SUBMIT_BUTTON'
        loadingLabel='AUTH.LOGIN.SUBMITTING_BUTTON'
      />
      <Languages />
    </form>
  )
}
